import { render } from "./AddressBookList.vue?vue&type=template&id=2c6d3fa2"
import script from "./AddressBookList.vue?vue&type=script&lang=js"
export * from "./AddressBookList.vue?vue&type=script&lang=js"

import "./AddressBookList.vue?vue&type=style&index=0&id=2c6d3fa2&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__